module.exports = __webpack_public_path__ + "static/common-background-6c4229c071b1313df728ddcba6a2e59e.png";